import Transcript from './transcript';
import AudioSync from './audio_sync';
import ChallengeMode from './challenge_mode';
import PlayerService from './player_service'
import TranslationService from './translation_service';
import BottomPopoverService from './bottom_popover_service';
import PlaybackSession from '../podcasts/playback_session';

document.addEventListener("turbolinks:load", function () {
  // turbolinks keeps the JS context across visits, so a poller from the previous
  // page would otherwise keep firing against an episode nobody is looking at.
  if (window.podcastPlaybackSession && typeof window.podcastPlaybackSession.stop === 'function') {
    window.podcastPlaybackSession.stop();
    window.podcastPlaybackSession = null;
  }

  const playerElement = document.getElementById('player');

  if (playerElement) {
    const transcriptContainer = document.getElementById('vtt-container') || document.getElementById('story-container');

    // Tier 1 (per-listener re-timed session) can only replace tier 2 before
    // playback starts, so the page must not autoplay while a session is in
    // flight. The user pressing play pins tier 2 for this view.
    const sessionsEnabled = !!transcriptContainer && transcriptContainer.dataset.sessionsEnabled === 'true';

    const playerService = new PlayerService(playerElement, { autoplay: !sessionsEnabled });

    var setupTranscript = function() {

      var mobileDeviceCheck = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      };

      let clickTimer;
      let translationProvider = 'deepl';

      let challengeMode;

      if (document.querySelector('.js-translation-provider')) {
        translationProvider = document.querySelector('.js-translation-provider').value;
      }

      const contentId = playerElement.dataset.contentId;
      const contentType = playerElement.dataset.contentType;
      const userId = playerElement.dataset.userId;

      const transcriptContainer = document.getElementById('vtt-container') || document.getElementById('story-container');
      const language = transcriptContainer.dataset.language;
      const targetLanguage = transcriptContainer.dataset.targetLanguage;
      const transcriptType = transcriptContainer.dataset.transcriptType;
      const transcriptUrl = transcriptContainer.dataset.transcript;
      const highlightWords = transcriptContainer.dataset.highlightWords !== undefined ? JSON.parse(transcriptContainer.dataset.highlightWords) : [];
      const learnedWords = transcriptContainer.dataset.learnedWords !== undefined ? JSON.parse(transcriptContainer.dataset.learnedWords) : [];
      const savedWords = transcriptContainer.dataset.savedWords !== undefined ? JSON.parse(transcriptContainer.dataset.savedWords) : [];
      const audioSyncEnabled = transcriptContainer.dataset.audioSyncEnabled ? transcriptContainer.dataset.audioSyncEnabled === 'true' : true;
      let storyContainer = transcriptContainer.id === 'story-container'

      const csrfToken = $('meta[name="csrf-token"]').attr('content');
      const premiumAccount = playerElement.dataset.premiumAccount;

      const translationService = new TranslationService(translationProvider, language, targetLanguage, csrfToken);
      const popoverService = !storyContainer ?
        new BottomPopoverService(translationService, language, contentId, contentType, csrfToken, premiumAccount, false, playerService) : null;

      const transcript = new Transcript(transcriptContainer, transcriptType, transcriptUrl, highlightWords, mobileDeviceCheck(), playerService, popoverService, translationService, learnedWords, savedWords);
      const audioSync = new AudioSync(playerService, transcriptContainer, transcriptType, mobileDeviceCheck());

      // setupTranscript() can run again (ActionCable transcript-ready); detach
      // the previous instance so two sync loops never drive the same player.
      if (window.audioSync && typeof window.audioSync.stop === 'function') {
        window.audioSync.stop();
      }

      // Make audioSync available globally
      window.audioSync = audioSync;
      
      if (!storyContainer) {
        challengeMode = new ChallengeMode(audioSync, playerService, popoverService.disposePopover);
      }

      // Listen for the ready event
      transcript.on('ready', () => {

        if (audioSyncEnabled) {
          audioSync.start();
        }
      });

      transcript.on('wordClick', (e) => {
        handleClick(e);
      });

      transcript.on('phraseSelected', (e) => {
        handleClick(e, true);
      });

      transcript.on('segmentClick', (e) => {
        if (challengeMode.challenge) {
          challengeMode.revealSentence(e);
        } else {
          transcript.setActiveElement(e, true);
        }
      });

      // Call setup to initialize
      transcript.setup();

      function handleClick(element, phraseSelected = false) {

        if (userId) {
          if (clickTimer == null) {
            // Single lcick
            clickTimer = setTimeout(function () {
              // Single click action
              transcript.setActiveElement(element, true, phraseSelected);
              clickTimer = null;
            }, 300); // Adjust this delay to suit your needs
          } else {
            // Double click
            clearTimeout(clickTimer);
            clickTimer = null;
            transcript.setActiveElement(element, false, phraseSelected);
          }
        } else {
          displaySignInModal();
        }
      }

      function displaySignInModal() {
        let link = document.querySelector('.js-signup-modal-btn');
        link.click();
      }

      $('.js-translation-provider').on('change', function (e) {
        e.preventDefault();
        translationService.setTranslationProvider(this.value);
      });

      $('.js-current-transcript').on('change', function (e) {
        e.preventDefault();
        // get selected option
        let selectedOption = $(this).find('option:selected');

        // send request to update transcript
        fetch(`/langua/contents/${contentId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            current_transcript_id: selectedOption.val()
          })
        }).then(response => response.json())
          .then(function (data) {
            // update transcript
            if (data.content.transcript_type == 'json') {
              if (data.content.transcript_url) {
                transcriptType = 'json';
                fetchAndDisplayJSON(data.content.transcript_url)
              }
            } else if (data.content.transcript_type == 'vtt') {
              transcriptType = 'vtt';
              fetchAndDisplayVTT(data.content.transcript_url)
            }

            // reset challenge
            challengeMode.resetChallenge();

          }).catch(function (error) {
            console.log(error);
          });
      });
    }

    window.setupTranscript = setupTranscript;

    if (transcriptContainer) {
      const transcriptUrl = transcriptContainer.dataset.transcript;
      let storyContainer = transcriptContainer.id === 'story-container'

      if (transcriptUrl || storyContainer) {
        window.setupTranscript();
      }
    }

    // ---- Podcast playback sessions (tier 1) ---------------------------------

    // Re-point the page at this listener's own copy: new audio, re-timed
    // transcript, sync on. Everything else on the page is untouched, so any
    // failure simply leaves tier 2 in place.
    function applyRetimedSession(payload) {
      if (!payload || !payload.transcriptUrl) {
        return;
      }

      // Never swap mid-playback, and never swap out from under restored
      // progress — a returning listener's position means nothing on a copy with
      // different ad breaks (content-time remapping is a follow-up).
      if (playerService.isPlaying() || playerService.getCurrentTime() > 0) {
        return;
      }

      if (payload.audioUrl) {
        const sourceElement = playerElement.querySelector('source');
        playerService.replaceSource(payload.audioUrl, sourceElement && sourceElement.getAttribute('type'));
      }

      transcriptContainer.dataset.transcript = payload.transcriptUrl;
      transcriptContainer.dataset.transcriptType = 'json';
      // The re-timed transcript matches the audio the listener will hear, so the
      // sync loop that tier 2 had to leave off can run.
      transcriptContainer.dataset.audioSyncEnabled = 'true';

      const dynamicAdWarning = document.getElementById('js-podcast-dynamic-ad-warning');
      if (dynamicAdWarning) {
        dynamicAdWarning.remove();
      }

      // setupTranscript() re-reads the dataset, stops the previous AudioSync and
      // re-renders from the new URL.
      window.setupTranscript();
    }

    // Re-reads the dataset each time, so podcast_episode.js can call it again
    // once an ActionCable transcript-ready flips the attribute on.
    function startPlaybackSession() {
      const container = document.getElementById('vtt-container');

      if (!container || container.dataset.sessionsEnabled !== 'true') {
        return;
      }

      // turbolinks keeps the previous page's timers alive; drop the old poller.
      if (window.podcastPlaybackSession && typeof window.podcastPlaybackSession.stop === 'function') {
        window.podcastPlaybackSession.stop();
      }

      const playbackSession = new PlaybackSession();
      window.podcastPlaybackSession = playbackSession;

      playbackSession.on('retimed', applyRetimedSession);
      playbackSession.on('failed', (payload) => {
        // Tier 2 (pinned copy) is already on screen; nothing to undo.
        console.debug('podcast playback session unavailable:', payload && payload.reason);
      });

      playbackSession.start(
        container.dataset.podcastEpisodeId,
        $('meta[name="csrf-token"]').attr('content'),
        container.dataset.sessionAuthToken
      );
    }

    window.startPodcastPlaybackSession = startPlaybackSession;

    if (sessionsEnabled) {
      startPlaybackSession();
    }
  }
});
